import { Component, ViewChild, forwardRef, Input } from '@angular/core';
import { Platform, ModalController, NavParams } from 'ionic-angular';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { CoMapPage } from '../../pages/co-map/co-map';
import { CallNumber } from '@ionic-native/call-number';
import { LocationsProvider } from '../../providers/locations/locations';
import moment from 'moment';
import { CoMapComponent } from '../co-map/co-map';
import { CoEventsExploreComponent } from '../co-events-explore/co-events-explore';
import { AppState } from '../../config/state';
/**
 * Generated class for the CoLocationComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-location-modular',
  templateUrl: 'co-location-modular.html',
  inputs: ["locationInfo", "inputLocationId", "displayImage"]
})
export class CoLocationModularComponent {
  todayHours: any = {};
  openToday: boolean = true;
  modal: any;
  locationInfo: any = "";
  currentPosition: any;
  libraryDistance: any = "";
  loadHours = false;
  locationAvailability: boolean;
  locationId: any;
  couldGetLocation: boolean = true;
  @Input("inputLocationId") inputLocationId: any;
  @Input("hideEvents") hideEvents: boolean;
  @Input("displayImage") displayImage: boolean;
  @ViewChild(CoMapComponent) innerMap: CoMapComponent;
  @ViewChild(forwardRef(() => CoEventsExploreComponent)) private eventsList: CoEventsExploreComponent;

  constructor(private launchNavigator: LaunchNavigator, public state: AppState, public platform: Platform, public modalCtrl: ModalController, private navParams: NavParams, private callNumber: CallNumber, public locationsProvider: LocationsProvider) {
    let locationID = navParams.data.location;
    if (navParams.data.location) {
      this.locationId = locationID;
    };
  }

  ngOnInit() {
    if (!this.navParams.data.location) {
      this.locationId = this.inputLocationId;
      this.displayImage = (this.displayImage ? this.displayImage : false);
      console.log(this.displayImage);
      // console.log(this.locationId)
    } else {
      // console.log('the nav params were sent')
    };
    this.getLocationInfo(this.locationId);
  };

  getLocationInfo(locationId) {
    this.locationsProvider.getLocation(locationId).then((res) => {
      if (res.phone[3] === " ") {
        let splitNum = res.phone.split(' ');
        let rejoinNum = [];
        rejoinNum.push(`(${splitNum[0]}) `, splitNum[1], `-${splitNum[2]}`);
        res.phone = rejoinNum.join('');
      } else if (res.phone[3] === '-') {
        let splitNum = res.phone.split('-');
        let rejoinNum = [];
        rejoinNum.push(`(${splitNum[0]}) `, splitNum[1], `-${splitNum[2]}`);
        res.phone = rejoinNum.join('');
      } else {
        res.phone = res.phone;
      }
      // this.todayHours = res.locationHours[i];  USED as test for closed days, set i to day of week branch is closed
      this.locationInfo = res;
      this.loadHours = true;
      this.innerMap.setCurrentLocation(this.locationInfo);
      this.innerMap.setCurrentLocation;
      this.eventsList.getLocationEvents(this.locationInfo.id);
      this.callDistances();
    });
    this.locationsProvider.getWeekHours(locationId, moment().format("MM/DD/YYYY")).then( (res) => {
      if(res && res.length > 0) {
        this.todayHours = res[moment().day()];
        if(this.todayHours.start === this.todayHours.end) this.openToday = false;
        if(this.todayHours.exceptionReason && this.todayHours.exceptionReason.length > 0) this.todayHours.exceptionReason = decodeURIComponent(this.todayHours.exceptionReason);
      }
    });
  }

  async callDistances() {
    let self = this;
    await this.locationsProvider.getUserLocation().then((res) => {
      if (res.lat === "" && res.lng === "") {
        self.couldGetLocation = false;
      } else {
        self.currentPosition = {
          latitude: res.lat,
          longitude: res.lng
        };
        self.couldGetLocation = true;
        self.getDistance();
      }
    }).catch(err => {});
  };

  email(address: string) {
    this.platform.ready().then(() => {
      open('mailto:' + address);
    })
  }

  async getDistance() {
    var radlat1 = Math.PI * this.currentPosition.latitude / 180;
    var radlat2 = Math.PI * this.locationInfo.locationLatitude / 180;
    var theta = this.currentPosition.longitude - this.locationInfo.locationLongitude;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    this.libraryDistance = dist.toFixed(1);
  }

  openMap(locationAddress: any) {
    this.modal = this.modalCtrl.create(CoMapPage, { data: locationAddress });
    this.modal.present();
  }

  openDirections(locationAddress: any) {
    if (this.state.mode !== 'desktop' && this.platform.is('cordova')) {
      this.launchNavigator.navigate(locationAddress.fullAddress)
        .then(
          success => alert('Launched navigator'),
          error => alert('Error launching navigator: ' + error)
        );
    } else {
      window.open("//google.com/maps/dir/?api=1&origin=&destination=" + locationAddress.locationLatitude + "," + locationAddress.locationLongitude, "_system");
    }
  }

  call(number: string) {
    this.callNumber.callNumber(number, true)
      .then(() => console.log('Launched dialer'))
      .catch(() => console.log('Error launching dialer'));
  }

}



// WEBPACK FOOTER //
// ./src/components/co-location-modular/co-location-modular.ts